import React, { Suspense } from 'react';

import { getIcon } from './helper';
import { IconName, IconProps } from './types';

const Icon = ({ name, ...props }: IconProps): JSX.Element => {
  const IconComponent = getIcon(name as IconName);

  return (
    <Suspense fallback={null}>
      <IconComponent name={name} {...props} />
    </Suspense>
  );
};

export default Icon;
